import { Button, ButtonStyles, Icons, ListItem, Tooltip } from '@silverfort/sf-components';
import { useMemo } from 'react';

const { CONDITIONS_OPTIONS, CONDITIONS_OPTIONS_VALUE_LABEL } = require('@silverfort-nodelibs/common/utils/consts');

const ResourceRow = ({
    title,
    extraTitle,
    subtitle,
    IconLeft,
    protocols = [],
    selected,
    onClick,
    onEdit,
    onDelete,
    showProtocols = true,
    disabled
}) => {
    const protocolsText =
        protocols.length === 0 ? '0 protocols' : `${protocols.length} ${protocols.length === 1 ? 'protocol' : 'protocols'}`;

    const truncatedTitle = useMemo(() => (title.length > 24 ? title.substr(0, 23) + '...' : title), [title]);

    return (
        <div
            className={`h-12 w-full rounded-lg items-center flex ${onClick ? 'hover:cursor-pointer' : ''} ${
                selected ? 'bg-[#F5FAFF] border border-sf-primary-500' : 'hover:bg-sf-light-100'
            }`}
            onClick={onClick}>
            <div className={extraTitle ? '' : 'flex-1'}>
                <Tooltip title={!onEdit && title.length > 24 ? title : undefined}>
                    <ListItem
                        title={onEdit ? title : truncatedTitle}
                        subtitle={subtitle}
                        IconLeft={IconLeft}
                        className={`bg-transparent hover:bg-transparent ${
                            onClick ? 'hover:cursor-pointer' : 'hover:cursor-default'
                        }`}
                        disabled={disabled}
                    />
                </Tooltip>
            </div>
            {extraTitle && (
                <div className="flex-1 items-center px-2">
                    <div className="h-6 px-2 items-center content-center rounded border border-sf-gray-100 w-fit text-sm font-normal">
                        {extraTitle}
                    </div>
                </div>
            )}
            {showProtocols && (
                <div className="px-2 items-center">
                    <div className="h-6 px-2 items-center content-center rounded bg-sf-primary-100 w-fit text-sm font-medium text-[#0D71C5]">
                        {protocolsText}
                    </div>
                </div>
            )}
            {!disabled && (
                <div onClick={(e) => e.stopPropagation()} className="flex px-2 items-center">
                    {onEdit && (
                        <Tooltip title={<div>Edit</div>}>
                            <Button
                                iconLeft={Icons.Edit}
                                onClick={onEdit}
                                iconSize={16}
                                buttonStyle={ButtonStyles.TertiarySolid}
                                className="bg-transparent"
                            />
                        </Tooltip>
                    )}
                    <Tooltip title={<div>Remove</div>}>
                        <Button
                            iconLeft={Icons.Cancel}
                            onClick={onDelete}
                            iconSize={16}
                            buttonStyle={ButtonStyles.TertiarySolid}
                            className="bg-transparent"
                        />
                    </Tooltip>
                </div>
            )}
        </div>
    );
};

export const GroupRow = ({ name, domainName, ...resourceRowProps }) => {
    return (
        <ResourceRow
            title={name}
            subtitle={domainName ? `(${domainName})` : undefined}
            IconLeft={Icons.UserGroup}
            {...resourceRowProps}
        />
    );
};

export const OURow = ({ name, domainName, ...resourceRowProps }) => {
    return (
        <ResourceRow
            title={name}
            subtitle={domainName ? `(${domainName})` : undefined}
            IconLeft={Icons.Folder}
            {...resourceRowProps}
        />
    );
};

export const ServerRow = ({ name, domainName, ...resourceRowProps }) => {
    return (
        <ResourceRow
            title={name}
            subtitle={domainName ? `(${domainName})` : undefined}
            IconLeft={Icons.Server}
            {...resourceRowProps}
        />
    );
};

export const IPRow = ({ ip, ...resourceRowProps }) => {
    return <ResourceRow title={ip} IconLeft={Icons.IP} {...resourceRowProps} />;
};

export const ConditionRow = ({ condition, ...resourceRowProps }) => {
    const typesIcons = {
        [CONDITIONS_OPTIONS.START_WITH.value]: Icons.TextStart,
        [CONDITIONS_OPTIONS.END_WITH.value]: Icons.TextEnd,
        [CONDITIONS_OPTIONS.CONTAINS.value]: Icons.TextContains
    };

    return (
        <ResourceRow
            title={CONDITIONS_OPTIONS_VALUE_LABEL[condition.conditionType]}
            extraTitle={condition.conditionString}
            IconLeft={typesIcons[condition.conditionType]}
            services={condition.services}
            protocols={condition.protocols ?? []}
            {...resourceRowProps}
        />
    );
};
